module.exports = __webpack_public_path__ + "img/info-3.356d8094.svg";